import React from "react";
import { Content } from "../../components/ui/ContentArea";
import { DatosAnioInputDashboard } from "@/components/User/DatosAnioInput/DatosAnioInputDashboard";

export const EmpresaInputPage: React.FC = () => {
	return (
		<Content className="p-5">
			<title>Editar Datos Anuales</title>
			<DatosAnioInputDashboard />
		</Content>
	);
};
